import fetch from 'isomorphic-fetch';
import Cookies from 'universal-cookie';
import { EventTypes } from 'redux-segment';
import {
  CREATE_REGISTRY_FROM_WEDDINGS,
  REGISTRY_PUBLISHED,
  RECEIVE_REGISTRY,
  REQUEST_REGISTRY,
  HAS_SHIPPING_ADDRESS,
} from './types/RegistryActionTypes';

// TODO: MOVE THIS AND USE FOR ALL REQUESTS!!!!
function handleErrors(response) { // eslint-disable-line
  if (!response.ok) {
    const error = new Error(response.statusText);
    error.response = response;
    throw error;
  }
  return response;
}

function requestRegistry() {
  return {
    type: REQUEST_REGISTRY
  };
}

function receiveRegistry(json) {
  return {
    type: RECEIVE_REGISTRY,
    payload: json
  };
}

function registryPublished() {
  return {
    type: REGISTRY_PUBLISHED
  };
}

function hasShippingAddress() {
  return {
    type: HAS_SHIPPING_ADDRESS
  };
}

export function createRegistry() {
  const cookies = new Cookies();
  cookies.set('checklistOnboard', true, 1);
  return dispatch => (
    fetch('/web-api/v1/registry/create_by_account_id',
      {
        credentials: 'same-origin',
        method: 'POST'
      })
      .then(() => dispatch({
        type: CREATE_REGISTRY_FROM_WEDDINGS,
        meta: {
          analytics: {
            eventType: EventTypes.track,
            eventPayload: {
              event: 'Registry Create From Weddings'
            }
          }
        }
      }))
  );
}

export function updateRegistryPublish(enable) {
  return dispatch => (
    fetch('/web-api/v1/registry/publish',
      {
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json'
        },
        method: 'POST',
        body: JSON.stringify({ enable })
      })
      .then(() => dispatch(registryPublished()))
  );
}

export function fetchRegistry() {
  return (dispatch) => {
    dispatch(requestRegistry());
    return fetch('/web-api/v1/registry',
      {
        credentials: 'same-origin',
      })
      .then(handleErrors)
      .then(response => response.json())
      .then(json => dispatch(receiveRegistry(json)));
  };
}

// TEMPORARY
export function fetchRegistryByCollectionItemId(collectionItemId) {
  return () => (
    fetch(`/api/v0/registry/collection-item-id/${collectionItemId}`,
      {
        credentials: 'same-origin'
      })
      .then(response => response.json())
  );
}

export function setShippingAddress(shippingAddress, validate) {
  return dispatch => (
    fetch('/api/v0/registry/shipping-address',
      {
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json'
        },
        method: 'POST',
        body: JSON.stringify({ shippingAddress, validate })
      })
      .then(handleErrors)
      .then(response => response.json())
      .then(() => dispatch(hasShippingAddress()))
      // .then(() => dispatch(updateRegistryPublish(true)))
      // .catch(() => dispatch(NotificationActions.error({ message: 'Something went wrong' })))
  );
}

export function updateShippingAddress(addressData, validate) {
  return dispatch => (
    fetch('/web-api/v1/address/update_shipping_address',
      {
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json'
        },
        method: 'POST',
        body: JSON.stringify({ addressData, validate })
      })
      .then(handleErrors)
      .then(response => response.json())
      .then((json) => {
        dispatch(hasShippingAddress());
        return json;
      })
  );
}

export function updateGroupGiftGoals() {
  return () => (
    fetch('/web-api/v1/registry/update_group_gift_goals',
      {
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json'
        },
        method: 'POST',
      })
      .then(handleErrors)
  );
}



/** WEBPACK FOOTER **
 ** ./src/actions/RegistryActions.js
 **/